import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pointHistory: [],
};

const memberPointSlice = createSlice({
  name: "memberPoint",
  initialState,
  reducers: {
    setPointHistory: (state, action) => {
      state.pointHistory = action.payload;
    },
    clearPointHistory: (state) => {
      state.pointHistory = [];
    },
  },
});

export const { setPointHistory, clearPointHistory } = memberPointSlice.actions;
export default memberPointSlice.reducer;
